import React, { useState } from "react";

export default function RatingCell({ value, column, readOnly, onCommit }) {
  const max = column?.settings?.max ?? 5;
  const [hover, setHover] = useState(0);
  const v = Number(value) || 0;
  const stars = Array.from({ length: max }, (_, i) => i + 1);

  return (
    <div className="cell-display rating">
      {stars.map((n) => {
        const filled = (hover || v) >= n;
        return (
          <span
            key={n}
            className={`star ${filled ? "filled" : ""}`}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onCommit(n === v ? null : n)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}
